import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { FtoReportState } from '../novelty-check-report-state';
import type { FtoReportContext } from '../novelty-check-report-context';
import { FtoTaskStep } from '@/domains/fto-report/enums';
import { Logger } from '@patsnap/tahiti-core';
import { FtoReportRetrievalResultReportModel } from '@/domains/fto-report/models/retrieval-result-report-model';
import { FtoReportTechEssentialService } from '../../retrieval-result-report-service';
import { FtoReportTaskStatusModel } from '@/domains/fto-report/models/task-status-model';

@injectable()
export class FtoReportSearchInputState implements FtoReportState {
    // eslint-disable-next-line max-params
    constructor(
        @inject(Logger)
        private readonly _logger: Logger,
        @inject(FtoReportRetrievalResultReportModel)
        private readonly _retrievalResultReportModel: FtoReportRetrievalResultReportModel,
        @inject(FtoReportTechEssentialService)
        private readonly _techEssentialService: FtoReportTechEssentialService,
        @inject(FtoReportTaskStatusModel)
        private readonly _noveltyCheckTaskStatusModel: FtoReportTaskStatusModel,
    ) { }

    getStep() {
        return FtoTaskStep.FTO_SEARCH_INPUT;
    }

    async enter(): Promise<void> {
        this._logger.info('进入编辑技术要点状态');
        this._switchTaskStep(FtoTaskStep.FTO_SEARCH_INPUT);
        // 获取之前的查新输入
        const techEssential = this._retrievalResultReportModel.modelData.techEssential;
        // 填充
        this._retrievalResultReportModel.update((model) => {
            model.techEssential = techEssential;
            return model;
        });
    }

    async exit(): Promise<void> {
        this._logger.info('离开编辑技术要点状态');
    }

    /**
     * 切换任务步骤
     * @param step 目标步骤
     */
    private _switchTaskStep(step: FtoTaskStep) {
        this._noveltyCheckTaskStatusModel.update(state => {
            state.taskStep = step;
            return state;
        });
    }

    async handleNext(context: FtoReportContext): Promise<void> {
        // 从 retrievalResultReportModel 中获取技术要点
        const techEssential = this._retrievalResultReportModel.modelData.techEssential;
        // 更新技术要点
        await this._techEssentialService.updateTechEssential(techEssential);

        // 从编辑技术要点状态进入技术特征识别开始状态
        const techFeatureState = context.getState(FtoTaskStep.TECH_FEATURE_PULL_START);
        await context.transitionTo(techFeatureState);
    }

    async handlePrevious(context: FtoReportContext): Promise<void> {
        const previousState = context.getPreviousState();
        if (previousState) {
            await context.transitionTo(previousState);
        }
    }
}
